import { mapGetters, mapActions } from 'vuex';

const accountMixin = {
  computed: {
    ...mapGetters('accounts', ['getActiveAccountRedacted', 'isUserConnected']),
  },
  methods: {
    ...mapActions('accounts', ['connectWeb3Modal', 'disconnectWeb3Modal']),
    connectWallet() {
      if (this.isUserConnected) return;
      this.connectWeb3Modal();
    },
    toggleWallet() {
      if (this.isUserConnected) {
        this.disconnectWeb3Modal();
      } else {
        this.connectWallet();
      }
    },
  },
};

export default accountMixin;
